import { render, staticRenderFns } from "./PlacesWorkPlanBtns.vue?vue&type=template&id=b4c3474e&"
import script from "./PlacesWorkPlanBtns.vue?vue&type=script&lang=js&"
export * from "./PlacesWorkPlanBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports